import { request } from '@/lib/api/http';
import {
  LOOKUP_NAMES,
  candidateRecordSchema,
  lookupsSchema,
  type CandidateRecord,
  type LookupName,
  type Lookups,
} from '@/lib/api/schemas';

/** One step's answers, merged server-side into the open application. */
export type SaveInput = Record<string, unknown>;

export function saveStep(input: SaveInput): Promise<CandidateRecord> {
  return request('/profile/candidate/save', {
    method: 'POST',
    body: input,
    schema: candidateRecordSchema,
  });
}

export async function fetchLookups(names: readonly LookupName[] = LOOKUP_NAMES): Promise<Lookups> {
  const raw = await request('/profile/candidate/lookups', {
    query: { lookup: names },
    schema: lookupsSchema,
  });
  const out: Lookups = {};
  for (const name of names) out[name] = raw[name] ?? [];
  return out;
}
